module.exports = __webpack_public_path__ + "img/nickys_hockey_bag.a8299764.jpg";